import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[decimalOnly]'
})
export class DecimalOnlyDirective {

  private regexStr = '^\\d+\\.?\\d{0,9}$';

  constructor(private el: ElementRef<HTMLInputElement>) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
      return;
    }
    if ((event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())) {
      return;
    }

    const input = this.el.nativeElement;
    const current = input.value;
    const start = input.selectionStart ?? current.length;
    const end = input.selectionEnd ?? current.length;
    const prospective = current.slice(0, start) + event.key + current.slice(end);

    if (!new RegExp(this.regexStr).test(prospective)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pasted = event.clipboardData?.getData('text') ?? '';
    const input = this.el.nativeElement;
    const start = input.selectionStart ?? input.value.length;
    const end = input.selectionEnd ?? input.value.length;
    const prospective = input.value.slice(0, start) + pasted + input.value.slice(end);

    if (new RegExp(this.regexStr).test(prospective)) {
      input.value = prospective;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  @HostListener('blur')
  onBlur() {
    const input = this.el.nativeElement;
    let v = input.value.trim();

    if (!v) {
      input.value = '0';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }

    let parts = v.split('.');
    if (parts.length > 2) {
      v = parts[0] + '.' + parts.slice(1).join('');
      parts = v.split('.');
    }
    if (parts[0] === '') parts[0] = '0';
    if (v.endsWith('.')) parts = [parts[0]];

    v = parts.join('.').replace(/[^0-9.]/g, '');

    if (isNaN(parseFloat(v))) v = '0';

    if (v !== input.value) {
      input.value = v;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}